import {createFileRoute} from "@tanstack/react-router";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {getAdminWorkspacesWithCaching} from "../workspace/-queries";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/a/_adminScaffold/ui-config")({
    validateSearch: (search: Record<string, unknown>): {workspaceId?: Uuid} => {
        const workspaceIdResult = uuidZodValidator.safeParse(search.workspaceId);
        return {
            ...(workspaceIdResult.success === true ? {workspaceId: workspaceIdResult.data} : {}),
        };
    },
    loader: async ({context}) => {
        const workspaces = await getAdminWorkspacesWithCaching({
            queryClient: context.queryClient,
            intellsysBaseUrl: context.intellsysBaseUrl,
            accessToken: context.authenticationStatus.accessToken,
        });
        return {
            accessToken: context.authenticationStatus.accessToken,
            intellsysBaseUrl: context.intellsysBaseUrl,
            workspaces: workspaces,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
